/* eslint-disable global-require */
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

import rootSaga from './sagas';
import rootReducer from './reducer';

export default (initialState, nextCtx) => {
  const sagaMiddleware = createSagaMiddleware();
  const composeEnhancers = (process.env.NODE_ENV !== 'production'
      && typeof window !== 'undefined'
      && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
    || compose;

  const isClient = typeof window !== 'undefined';

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(sagaMiddleware))
  );

  if (process.env.NODE_ENV === 'development' && isClient) {
    window.store = store;
  }

  store.sagaTask = sagaMiddleware.run(rootSaga, nextCtx);

  return store;
};
